import {createSlice} from "@reduxjs/toolkit";

export const projectInfoSlice = createSlice({
    name: "projectInfo",
    initialState: {
        ID: null,
        teamMembers: null,
        scenes: null,
        currentProject: null,
    },
    reducers: {
        setProjectId: (state, action) => {
            state.ID = action.payload;
        },
        setTeamMembers: (state, action) => {
            state.teamMembers = action.payload;
        },
        setScenes: (state, action) => {

            state.scenes = action.payload;
        },
        setCurrentProject: (state, action) => {
            state.currentProject = action.payload;
        },
    },
});

export const {setProjectId, setTeamMembers, setScenes, setCurrentProject} = projectInfoSlice.actions;

export const selectTeamMembers = (state) => state.projectInformation.teamMembers;
export const selectScenes = (state) => state.projectInformation.scenes;
export const selectCurrentProject = (state) => state.projectInformation.currentProject;

export default projectInfoSlice.reducer;

